import { ArticleFooterTheme } from '@/components/ArticleFooter/theme';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';
import { StandaloneTag } from '../Tag';

const $ = GenericSlotFactory({ theme: ArticleFooterTheme });

const Base = $({ as: 'div', slot: 'base' });
const Tags = $({ as: 'ul', slot: 'tags' });
const Tag = GenericSlot({ as: StandaloneTag, theme: ArticleFooterTheme.Tag });

export const ArticleFooter = Object.assign(Base, {
  Tags,
  Tag,
});
